import { uploadEventImage } from "../../api";
import {
  changeWebTax,
  createTickets,
  createVariationProduct,
  deleteSector,
  editEvent,
  editSector,
  fetchCategories,
  fetchEvents,
  fetchSectors,
  registerEvent,
  registerSector,
  changeStatusEvent,
  changeTicketsOnEventList,
  addOrRemoveTemplates,
  getEventInfo,
  deleteTicketsProductsOrRecharges,
  deleteVariationProduct,
  insertBulkTickets,
  canChangeEventType,
  removeDateFromRecurringEvent,
} from "../../api/newEvent";
import eventBus from "../../utils/eventBus";
import {
  getSlug,
  adjustTime,
  extractAndRemoveLocale,
  processEventName,
  convertObjectToArray,
} from "../../utils";
import { i18n } from "../../main";
import router from "../../router";

export function transformToXmlFormat(name, nameLocales, defaultLocale) {
  let result = "";
  result += `<${defaultLocale}>${name}</${defaultLocale}>`;
  for (const [key, value] of Object.entries(nameLocales)) {
    if (key !== defaultLocale && value) {
      result += `<${key}>${value}</${key}>`;
    }
  }
  return result;
}

export const getDefaultState = () => {
  return {
    selectedLocales: [],
    typeImageSelected: "destaque",
    categories: [],
    currentEvent: {},
    idEvent: "",
    loadingCategories: false,
    loadingEvents: false,
    loadingEvent: false,
    modalLoadingEvent: false,
    loadingDoubleEvent: false,
    eventBasicData: {
      name: "",
      description: "",
      expandDescription: false,
      urlLink: "",
      category: null,
      frequency: "UNICO",
      eventDate: null,
      saleStart: null,
      saleEnd: null,
      location: "",
      showMap: true,
      country: "",
      state: "",
      city: "",
    },
    eventSectorData: {
      hasSector: false,
      sectors: [],
    },
    eventImages: [],
    eventImagesLoading: false,
    eventSettingsData: {
      viewType: "",
      emphasis: false,
      changeBearer: false,
      limitPerCustomer: 5,
      url: "",
      hasElevenAccess: false,
      hasFacial: false,
      accessPeriodStart: null,
      accessPeriodEnd: null,
      accessQuantity: 1,
      showAgroupedEventsOnElevenTickets: false,
      hasAgroupedEvents: false,
      agroupedEvents: [],
      balanceSettings: {
        dias: "2",
        tipo: "pos",
        saque: "manual",
      },
      balanceReleased: "80",
      commissionWeb: "CONVENIENCIA",
      typeTaxWeb: "percent",
      taxWeb: "10",
      minimumTax: "2.50",
      commissionPos: "COMISSAO",
      typeTaxPos: "percent",
      taxPos: "7.40",
      hasProcessingTax: false,
      processingTax: "0",
      cancellationPeriod: "default",
      cancellationDays: "7",
      cancellationHours: "24",
      publication: "ATIVO",
      applyAllAccessPeriods: false,
      applyAllCommissions: false,
    },
    eventSettingsDataCached: {},
    defaultTicketList: {
      id: 0,
      name: "",
      nameLocales: { "en-US": "", "es-ES": "" },
      sector: "",
      batch: 0,
      previousBatch: "",
      order: 0,
      price: 0,
      quantity: 0,
      ticketDate: null,
      half: false,
      salesChannel: "ECOMMERCE;IFRAME;LINK",
      description: "",
      accessPeriodStart: "",
      accessPeriodEnd: "",
      salesPeriodStart: "",
      salesPeriodEnd: "",
      accessQuantity: 1,
      dateChangeBatch: null,
      isCourtesy: false,
      blockQuantity: null,
      commissionWeb: "CONVENIENCIA",
      typeTaxWeb: "percent",
      taxWeb: "10",
      minimumTax: "2.50",
      commissionPos: "COMISSAO",
      typeTaxPos: "percent",
      taxPos: "7.40",
      hasProcessingTax: false,
      processingTax: "0",
      type: "INGRESSO",
      status: "INATIVO",
      templateTicketWeb: null,
      templateTicketPos: null,
    },
    defaultRechargeList: {
      id: 0,
      price: 0,
      quantity: 0,
      order: 0,
      salesPeriodStart: "",
      salesPeriodEnd: "",
      salesChannel: "ECOMMERCE;IFRAME;LINK",
      description: "",
      accessPeriodStart: "",
      accessPeriodEnd: "",
      accessQuantity: 0,
      blockQuantity: null,
      type: "RECARGA",
      status: "INATIVO",
      commissionWeb: "CONVENIENCIA",
      typeTaxWeb: "percent",
      taxWeb: "10",
      minimumTax: "2.50",
      elevenCash: "",
      hasProcessingTax: false,
      processingTax: "0",
    },
    defaultProductList: {
      id: 0,
      images: [],
      name: "",
      nameLocales: { "en-US": "", "es-ES": "" },
      price: 0,
      quantity: 0,
      order: 0,
      variation: [],
      salesChannel: "ECOMMERCE;IFRAME;LINK",
      accessPeriodStart: "",
      accessPeriodEnd: "",
      accessQuantity: 1,
      description: "",
      type: "PRODUTO",
      status: "INATIVO",
      commissionWeb: "CONVENIENCIA",
      typeTaxWeb: "percent",
      taxWeb: "10",
      minimumTax: "2.50",
      commissionPos: "COMISSAO",
      typeTaxPos: "percent",
      taxPos: "7.40",
      hasProcessingTax: false,
      processingTax: "0",
      disabled: "quantity",
    },
    eventType: "",
    ticketList: [],
    productList: [],
    rechargeList: [],

    selectedDateToTickets: [],
    datesOfTickets: [],
    loadingBulkEvent: false,
  };
};

const state = getDefaultState();

const getters = {
  getSelectedLocales: state => state.selectedLocales,
  getCategories: state => state.categories,
  getCurrentEvent: state => state.currentEvent,
  getIdEvent: state => state.idEvent,
  getLoadingCategories: state => state.loadingCategories,
  getLoadingEvents: state => state.loadingEvents,
  getLoadingEvent: state => state.loadingEvent,
  getModalLoadingEvent: state => state.modalLoadingEvent,
  getEventBasicData: state => state.eventBasicData,
  getEventSectorData: state => state.eventSectorData,
  getEventSettingsData: state => state.eventSettingsData,
  getEventSettingsDataCached: state => state.eventSettingsDataCached,
  getEventImages: state => state.eventImages,
  getEventImagesLoading: state => state.eventImagesLoading,
  getTypeImageSelected: state => state.typeImageSelected,
  getSlug: state => state.eventSettingsData.url,
  getEventType: state => state.eventType,
  getLoadingDoubleEvent: state => state.loadingDoubleEvent,

  getTicketList: state => state.ticketList,
  getTicketListFiltered: state => {
    if (
      state.eventBasicData.frequency === "RECORRENTE" &&
      !state.selectedDateToTickets.includes("all")
    ) {
      return state.ticketList.filter(ticket =>
        state.selectedDateToTickets.includes(ticket.ticketDate)
      );
    } else {
      return state.ticketList;
    }
  },

  getProductList: state => state.productList,
  getRechargeList: state => state.rechargeList,

  getIsRecurringEvent: state => state.eventBasicData.frequency === "RECORRENTE",
  getSelectedDateToTickets: state => state.selectedDateToTickets,
  getAllDatesOfTickets: state => state.datesOfTickets,
  getLoadingBulkEvent: state => state.loadingBulkEvent,
};

const actions = {
  async changeEventStatus({ dispatch, getters }, { id, status }) {
    try {
      const res = await changeStatusEvent({
        loja: getters.storeSequencial,
        idevent: id,
        status: status,
      });
      dispatch("showSnackbarSuccess", res.data.msg);
    } catch (error) {
      console.error(error);
    }
  },
  async updateChangeVariations({ getters, dispatch }, variations) {
    try {
      const res = await changeTicketsOnEventList({
        loja: getters.storeSequencial,
        variacoes: variations,
      });
      dispatch("showSnackbarSuccess", res.data.mensagem);
    } catch (error) {
      console.error(error);
    }
  },
  async getCategories({ commit }) {
    commit("setLoadingCategories", true);
    try {
      const res = await fetchCategories();
      commit("setCategories", res.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      commit("setLoadingCategories", false);
    }
  },
  async revertTaxes({ dispatch }, idproduto) {
    try {
      const res = await changeWebTax(idproduto);
      alert(res.data.msg);
      dispatch("getEvents");
    } catch (error) {
      console.error(error);
    }
  },
  async getEvents({ commit, getters }) {
    commit("setLoadingEvents", true);
    try {
      const res = await fetchEvents(getters.storeSequencial);
      commit("setEvents", res.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      commit("setLoadingEvents", false);
    }
  },
  async createEvent({ commit, dispatch, getters }) {
    commit("setLoadingEvent", true);
    const locale = i18n.locale;
    const slug = await getSlug(
      getters.getEventBasicData.name,
      locale,
      router.currentRoute.path
    );

    const infoData = {
      loja: getters.storeSequencial,
      idcategoria: getters.getEventBasicData.category,
      url_link: getters.getEventBasicData.urlLink,
      idloja: getters.storeInfo?.idloja,
      descricao: getters.getEventBasicData.name,
      descritivo: getters.getEventBasicData.description || "",
      dthr_inicio: getters.getEventBasicData.saleStart,
      dthr_termino: getters.getEventBasicData.saleEnd,
      end_local: getters.getEventBasicData.location,
      end_cidade: getters.addresses?.city?.dsc,
      end_estado: getters.addresses?.state?.iso_full,
      end_pais: getters.addresses?.country?.dsc,
      dthr_evento: getters.getEventBasicData.eventDate,
      show_map: getters.getEventBasicData.showMap ? 1 : 0,
      tipo_evento: getters.getEventBasicData.frequency,
      slug: slug,
      tipo: getters.getEventType,
      status: "RASCUNHO",
    };
    try {
      await registerEvent(infoData).then(async response => {
        commit("setIdEvent", response.data.idproduto);
        commit("setEventSettingsData", {
          ...state.eventSettingsData,
          accessPeriodStart: response.dthr_inicio_checkin,
          accessPeriodEnd: response.dthr_termino_checkin,
          commissionWeb: response.data.tipo_taxa_web || "COMISSAO",
          typeTaxWeb:
            response.data.taxa_conveniencia_porcentagem_custom_web > 0 ||
            response.data.comissao_porcentagem_custom_web > 0
              ? "percent"
              : "value",
          taxWeb:
            [
              response.data.comissao_web,
              response.data.taxa_conveniencia_web,
              response.data.taxa_conveniencia_porcentagem_custom_web,
              response.data.comissao_porcentagem_custom_web,
            ].find(value => value > 0) || 0,
          minimumTax: response.data.taxa_minima,
          commissionPos: response.data.tipo_taxa_pos || "CONVENIENCIA",
          typeTaxPos:
            response.data.taxa_conveniencia_porcentagem_custom_pos > 0 ||
            response.data.comissao_porcentagem_custom_pos > 0
              ? "percent"
              : "value",
          taxPos:
            [
              response.data.comissao_pos,
              response.data.taxa_conveniencia_pos,
              response.data.taxa_conveniencia_porcentagem_custom_pos,
              response.data.comissao_porcentagem_custom_pos,
            ].find(value => value > 0) || 0,
          hasProcessingTax: response.data.taxa_processamento > 0,
          processingTax: response.data.taxa_processamento,
          balanceSettings: getDefaultState().eventSettingsData.balanceSettings,
          balanceReleased: getDefaultState().eventSettingsData.balanceReleased,
          accessQuantity: getDefaultState().eventSettingsData.accessQuantity,
        });
        getters.getEventSettingsData.url = slug;
        if (
          getters.getEventType === "EVENTO" &&
          !router.currentRoute.path.includes("duplicar-evento") &&
          !getters.getIsRecurringEvent
        ) {
          await dispatch("addNewPaidTicket");
        }
      });
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      commit("setLoadingEvent", false);
    }
  },
  async updateEvent({ getters, commit, dispatch }) {
    commit("setLoadingEvent", true);
    commit("setModalLoadingEvent", true);
    try {
      const evento = await dispatch("getEventToPayload");
      const ingressos = await dispatch("getTicketsToPayload");

      const data = {
        evento,
        ingressos,
        combos: {},
        pre_visualizacao: {},
        cashless: {},
      };

      commit("setCurrentEvent", data);
      await editEvent(getters.getIdEvent, {
        loja: getters.storeSequencial,
        ...data,
      });
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      commit("setLoadingEvent", false);
      commit("setModalLoadingEvent", false);
    }
  },
  getSectors({ getters }, idEvent) {
    try {
      fetchSectors({ idevent: idEvent, loja: getters.storeSequencial }).then(
        response => {
          if (response.data?.length > 0) {
            getters.getEventSectorData.sectors = response.data;
            getters.getEventSectorData.hasSector = true;
          }
        }
      );
    } catch (error) {
      console.error(error);
    }
  },
  async createSector({ getters, dispatch }, sector) {
    try {
      await registerSector({
        description: sector,
        producer: getters.storeSequencial,
        idevent: getters.getIdEvent,
      });
      dispatch("getSectors", getters.getIdEvent);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async updateSector({ getters }, sectors) {
    try {
      await editSector({
        loja: getters.storeSequencial,
        idevent: getters.getIdEvent,
        sectors: sectors,
      }).then(response => {
        if (getters.getEventSectorData && getters.getEventSectorData.sectors) {
          getters.getEventSectorData.sectors = response.data;
        }
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async deleteSector({ getters }, idSector) {
    try {
      await deleteSector({
        idsector: idSector,
        loja: getters.storeSequencial,
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  addTicketToState(
    { commit, state, getters },
    { response, infoOverrides = {} }
  ) {
    const date = getters.getIsRecurringEvent
      ? getters.getSelectedDateToTickets[0]
      : null;
    commit("addTicketToList", {
      ...state.defaultTicketList,
      idproduto_variacao: response.idproduto_variacao,
      nidvariacao: response.nidvariacao,
      ticketDate: date,
      accessPeriodStart: response.dthr_inicio_checkin,
      accessPeriodEnd: response.dthr_termino_checkin,
      commissionWeb: response.tipo_taxa_web || "COMISSAO",
      typeTaxWeb:
        response.taxa_conveniencia_porcentagem_custom_web > 0 ||
        response.comissao_porcentagem_custom_web > 0
          ? "percent"
          : "value",
      taxWeb:
        [
          response.comissao_web,
          response.taxa_conveniencia_web,
          response.taxa_conveniencia_porcentagem_custom_web,
          response.comissao_porcentagem_custom_web,
        ].find(value => value > 0) || 0,
      minimumTax: response.taxa_minima,
      commissionPos: response.tipo_taxa_pos || "CONVENIENCIA",
      typeTaxPos:
        response.taxa_conveniencia_porcentagem_custom_pos > 0 ||
        response.comissao_porcentagem_custom_pos > 0
          ? "percent"
          : "value",
      taxPos:
        [
          response.comissao_pos,
          response.taxa_conveniencia_pos,
          response.taxa_conveniencia_porcentagem_custom_pos,
          response.comissao_porcentagem_custom_pos,
        ].find(value => value > 0) || 0,
      hasProcessingTax: response.taxa_processamento > 0,
      processTax: response.taxa_processamento,
      ...infoOverrides,
    });
  },
  addNewPaidTicket({ getters, dispatch }) {
    if (getters.getIsRecurringEvent && !getters.getSelectedDateToTickets) {
      return dispatch(
        "showSnackbarError",
        "Selecione uma data para criar o ingresso"
      );
    }
    try {
      createTickets({
        idevent: getters.getIdEvent,
        loja: getters.storeSequencial,
        type: "INGRESSO",
      }).then(response => {
        dispatch("addTicketToState", {
          response: response.data,
        });
      });
    } catch (error) {
      console.error(error);
    }
  },
  addNewHalfTicket({ dispatch, getters }, ticket) {
    if (ticket.price === 0) {
      return dispatch(
        "showSnackbarError",
        i18n.t("new-event.ticket-management.tickets.error-half-ticket")
      );
    } else {
      try {
        createTickets({
          idevent: getters.getIdEvent,
          loja: getters.storeSequencial,
          type: "INGRESSO",
        }).then(response => {
          dispatch("addTicketToState", {
            response: response.data,
            infoOverrides: {
              price: ticket.price / 2,
              name: `${ticket.name} - (${i18n.t("common.half")})`,
              half: true,
              disabled: ["price"],
            },
          });
        });
      } catch (error) {
        console.error(error);
      }
    }
  },
  addTicketNextBatch({ dispatch, getters }, ticket) {
    const hasAnotherTicketWithSamePreviousBatch = getters.getTicketList.some(
      tkt => tkt.previousBatch === ticket.idproduto_variacao
    );
    if (hasAnotherTicketWithSamePreviousBatch) {
      return dispatch(
        "showSnackbarError",
        i18n.t(
          "new-event.ticket-management.tickets.error-multiple-next-batches-from-same-previous"
        )
      );
    }
    if (!ticket.batch) {
      return dispatch(
        "showSnackbarError",
        i18n.t("new-event.ticket-management.tickets.error-batch-ticket")
      );
    }
    if (getters.getEventSectorData?.hasSector && !ticket.sector) {
      return dispatch(
        "showSnackbarError",
        i18n.t("new-event.ticket-management.tickets.error-sector-ticket")
      );
    }
    try {
      createTickets({
        idevent: getters.getIdEvent,
        loja: getters.storeSequencial,
        type: "INGRESSO",
      }).then(response => {
        dispatch("addTicketToState", {
          response: response.data,
          infoOverrides: {
            previousBatch: ticket.idproduto_variacao,
            batch: ticket.batch + 1,
            sector: ticket.sector,
            disabled: ["batch", "sector"],
          },
        });
        const ticketToUpdate = getters.getTicketList.find(
          tkt => tkt.idproduto_variacao === ticket.idproduto_variacao
        );
        if (ticketToUpdate) {
          ticketToUpdate.disabled = ticketToUpdate.disabled || [];
          if (!ticketToUpdate.disabled.includes("batch")) {
            ticketToUpdate.disabled.push("batch");
          }
          if (!ticketToUpdate.disabled.includes("sector")) {
            ticketToUpdate.disabled.push("sector");
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
  },
  addNewCourtesyTicket({ dispatch, getters }) {
    try {
      createTickets({
        idevent: getters.getIdEvent,
        loja: getters.storeSequencial,
        type: "INGRESSO",
      }).then(response => {
        dispatch("addTicketToState", {
          response: response.data,
          infoOverrides: {
            disabled: ["price"],
            isCourtesy: true,
          },
        });
      });
    } catch (error) {
      console.error(error);
    }
  },
  async removeItem(
    { commit, state, getters },
    { item, listName, mutationName }
  ) {
    try {
      const response = await deleteTicketsProductsOrRecharges({
        loja: getters.storeSequencial,
        idproduto_variacao: item.idproduto_variacao,
      });
      if (response && response.status === 200) {
        const newList = state[listName].filter(selectedItem => {
          return selectedItem.idproduto_variacao !== item.idproduto_variacao;
        });
        commit(mutationName, newList);
      } else {
        throw new Error();
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async removeTicket({ dispatch }, ticket) {
    try {
      await dispatch("removeItem", {
        item: ticket,
        listName: "ticketList",
        mutationName: "setTicketList",
      });
      dispatch(
        "showSnackbarSuccess",
        i18n.t("new-event.ticket-management.tickets.delete-success")
      );
    } catch (error) {
      console.error(error);
    }
  },
  async removeRecharge({ dispatch }, recharge) {
    try {
      await dispatch("removeItem", {
        item: recharge,
        listName: "rechargeList",
        mutationName: "setRechargeList",
      });
      dispatch(
        "showSnackbarSuccess",
        i18n.t("new-event.ticket-management.recharges.delete-success")
      );
    } catch (error) {
      console.error(error);
    }
  },
  async removeProduct({ dispatch }, product) {
    try {
      await dispatch("removeItem", {
        item: product,
        listName: "productList",
        mutationName: "setProductList",
      });
      dispatch(
        "showSnackbarSuccess",
        i18n.t("new-event.ticket-management.products.delete-success")
      );
    } catch (error) {
      console.error(error);
    }
  },
  doubleTicket({ commit, getters, dispatch }, ticket) {
    if (ticket.batch > 0) {
      return dispatch(
        "showSnackbarError",
        i18n.t("new-event.ticket-management.tickets.error-no-batch-ticket")
      );
    }
    try {
      createTickets({
        idevent: getters.getIdEvent,
        loja: getters.storeSequencial,
        type: "INGRESSO",
      }).then(response => {
        commit("addTicketToList", {
          ...ticket,
          idproduto_variacao: response.data.idproduto_variacao,
          nidvariacao: response.data.nidvariacao,
        });
      });
    } catch (error) {
      console.error(error);
    }
  },
  async doubleProduct({ commit, getters }, product) {
    try {
      const response = await createTickets({
        idevent: getters.getIdEvent,
        loja: getters.storeSequencial,
        type: "PRODUTO",
      });
      if (product?.variation?.length > 0) {
        const newVariations = await Promise.all(
          product?.variation?.map(async variation => {
            try {
              const varResponse = await createVariationProduct({
                loja: getters.storeSequencial,
                idevent: getters.getIdEvent,
                idproduto_variacao: response.data.idproduto_variacao,
              });
              const newVariation = {
                color: variation.color,
                size: variation.size,
                quantity: variation.quantity,
                status: variation.status,
                ...varResponse.data,
              };
              commit("addProductVariationToList", {
                productListId: response.data.idproduto_variacao,
                variation: newVariation,
              });

              return newVariation;
            } catch (error) {
              console.error(error);
            }
          })
        );
        product.variation = newVariations;
      }
      commit("addProductToList", {
        ...product,
        idproduto_variacao: response.data.idproduto_variacao,
        nidvariacao: response.data.nidvariacao,
      });
    } catch (error) {
      console.error(error);
    }
  },
  addNewRecharge({ commit, state, getters }) {
    try {
      createTickets({
        idevent: getters.getIdEvent,
        loja: getters.storeSequencial,
        type: "RECARGA",
      }).then(response => {
        commit("addRechargeToList", {
          ...state.defaultRechargeList,
          idproduto_variacao: response.data.idproduto_variacao,
          nidvariacao: response.data.nidvariacao,
          salesPeriodStart: getters.getEventBasicData.saleStart,
          salesPeriodEnd: getters.getEventBasicData.saleEnd,
          commissionWeb: response.data.tipo_taxa_web || "COMISSAO",
          typeTaxWeb:
            response.data.taxa_conveniencia_porcentagem_custom_web > 0 ||
            response.data.comissao_porcentagem_custom_web > 0
              ? "percent"
              : "value",
          taxWeb:
            [
              response.data.comissao_web,
              response.data.taxa_conveniencia_web,
              response.data.taxa_conveniencia_porcentagem_custom_web,
              response.data.comissao_porcentagem_custom_web,
            ].find(value => value > 0) || 0,
          minimumTax: response.data.taxa_minima,
          commissionPos: response.data.tipo_taxa_pos || "CONVENIENCIA",
          typeTaxPos:
            response.data.taxa_conveniencia_porcentagem_custom_pos > 0 ||
            response.data.comissao_porcentagem_custom_pos > 0
              ? "percent"
              : "value",
          taxPos:
            [
              response.data.comissao_pos,
              response.data.taxa_conveniencia_pos,
              response.data.taxa_conveniencia_porcentagem_custom_pos,
              response.data.comissao_porcentagem_custom_pos,
            ].find(value => value > 0) || 0,
          hasProcessingTax: response.data.taxa_processamento > 0,
          processTax: response.data.taxa_processamento,
        });
      });
    } catch (error) {
      console.error(error);
    }
  },
  addNewProduct({ commit, state, getters }) {
    try {
      createTickets({
        idevent: getters.getIdEvent,
        loja: getters.storeSequencial,
        type: "PRODUTO",
      }).then(response => {
        commit("addProductToList", {
          ...state.defaultProductList,
          id: response.data.idproduto_variacao,
          idproduto_variacao: response.data.idproduto_variacao,
          nidvariacao: response.data.nidvariacao,
          commissionWeb: response.data.tipo_taxa_web || "COMISSAO",
          accessPeriodStart: adjustTime(
            getters.getEventBasicData.eventDate,
            -12
          ),
          accessPeriodEnd: adjustTime(getters.getEventBasicData.eventDate, +12),
          typeTaxWeb:
            response.data.taxa_conveniencia_porcentagem_custom_web > 0 ||
            response.data.comissao_porcentagem_custom_web > 0
              ? "percent"
              : "value",
          taxWeb:
            [
              response.data.comissao_web,
              response.data.taxa_conveniencia_web,
              response.data.taxa_conveniencia_porcentagem_custom_web,
              response.data.comissao_porcentagem_custom_web,
            ].find(value => value > 0) || 0,
          minimumTax: response.data.taxa_minima,
          commissionPos: response.data.tipo_taxa_pos || "CONVENIENCIA",
          typeTaxPos:
            response.data.taxa_conveniencia_porcentagem_custom_pos > 0 ||
            response.data.comissao_porcentagem_custom_pos > 0
              ? "percent"
              : "value",
          taxPos:
            [
              response.data.comissao_pos,
              response.data.taxa_conveniencia_pos,
              response.data.taxa_conveniencia_porcentagem_custom_pos,
              response.data.comissao_porcentagem_custom_pos,
            ].find(value => value > 0) || 0,
          hasProcessingTax: response.data.taxa_processamento > 0,
          processTax: response.data.taxa_processamento,
        });
      });
    } catch (error) {
      console.error(error);
    }
  },
  addNewVariationOnProduct({ commit, state, getters }, productListId) {
    try {
      createVariationProduct({
        loja: getters.storeSequencial,
        idevent: state.idEvent,
        idproduto_variacao: productListId,
      }).then(response => {
        commit("addProductVariationToList", {
          productListId: productListId,
          variation: {
            color: response.data.cor,
            size: response.data.tamanho,
            quantity: response.data.quantidade,
            ...response.data,
          },
        });
      });
    } catch (error) {
      console.error(error);
    }
  },
  async deleteVariationOnProduct(
    { getters, commit, dispatch },
    { eventData, variation }
  ) {
    try {
      const response = await deleteVariationProduct({
        loja: getters.storeSequencial,
        idproduto_variacao: eventData.idproduto_variacao,
        idvariacao_produto: variation.idvariacao_produto,
      });
      if (response && response.status === 200) {
        commit("deleteProductVariationToList", { eventData, variation });
        dispatch(
          "showSnackbarSuccess",
          i18n.t(
            "new-event.ticket-management.products.delete-variation-success"
          )
        );
      } else {
        throw new Error();
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async uploadNewEventImage({ commit, getters }, content) {
    commit("setEventImagesLoading", true);
    try {
      const response = await uploadEventImage(content);
      const obj = {
        url: response.data.url,
        type: content.image,
      };
      commit("setEventImages", [...getters.getEventImages, obj]);
      if (content.image === "imagem1") {
        const secondResponse = await uploadEventImage({
          ...content,
          image: "imagem2",
        });
        const secondObj = {
          url: secondResponse.data.url,
          type: "imagem2",
        };
        commit("setEventImages", [...getters.getEventImages, secondObj]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      commit("setEventImagesLoading", false);
      eventBus.$emit("upload-image");
    }
  },
  addAndRemoveTemplatePOS({ getters }, { action, file, id }) {
    try {
      addOrRemoveTemplates({
        action,
        file,
        id,
        tipo: "POS",
        loja: getters.storeSequencial,
      });
    } catch (error) {
      console.error(error);
    }
  },
  addAndRemoveTemplateWEB({ getters }, { action, file, id }) {
    try {
      addOrRemoveTemplates({
        action,
        file,
        id,
        tipo: "WEB",
        loja: getters.storeSequencial,
      });
    } catch (error) {
      console.error(error);
    }
  },
  cleanAll({ commit }) {
    commit("resetState");
  },
  async getEventToPayload({ getters }) {
    // basic data
    const infoData = {
      loja: getters.storeSequencial,
      idcategoria: getters.getEventBasicData.category,
      url_link: getters.getEventBasicData.urlLink,
      idloja: getters.storeInfo.idloja,
      descricao: getters.getEventBasicData.name,
      descritivo: getters.getEventBasicData.description || "",
      ver_mais: getters.getEventBasicData.expandDescription ? 1 : 0,
      dthr_inicio: getters.getEventBasicData.saleStart,
      dthr_termino: getters.getEventBasicData.saleEnd,
      end_local: getters.getEventBasicData.location,
      end_cidade: getters.addresses?.city?.dsc,
      end_estado: getters.addresses?.state?.iso_full,
      end_pais: getters.addresses?.country?.dsc,
      dthr_evento:
        getters.getEventBasicData.frequency === "UNICO"
          ? getters.getEventBasicData.eventDate
          : null,
      show_map: getters.getEventBasicData.showMap ? 1 : 0,
      tipo_evento: getters.getEventBasicData.frequency,
      slug: getters.getEventSettingsData.url,
      tipo: getters.getEventType,
    };

    //imagens
    const imagensObject = getters.getEventImages.reduce((acc, item) => {
      acc[item.type] = item.url;
      return acc;
    }, {});
    const imagensJsonString = JSON.stringify(imagensObject);

    //event settings
    const settingsData = {
      pre_venda: getters.getEventSettingsData.viewType ? true : false,
      dthr_pre_venda: getters.getEventSettingsData.viewType,
      destaque: getters.getEventSettingsData.emphasis,
      limite_venda_cpf_por_tipo: {
        ingresso: getters.getEventSettingsData.limitPerCustomer,
        produto: 15,
        recarga: 15,
      },
      slug: getters.getEventSettingsData.url,
      troca_portador: getters.getEventSettingsData.changeBearer ? 1 : 0,
      prod_agrupamento: getters.getEventSettingsData.hasAgroupedEvents,
      exibe_agrupamento: getters.getEventSettingsData.hasAgroupedEvents
        ? getters.getEventSettingsData.showAgroupedEventsOnElevenTickets
        : false,
      nidprod_agrupamento: getters.getEventSettingsData.hasAgroupedEvents
        ? Array.isArray(getters.getEventSettingsData.agroupedEvents)
          ? getters.getEventSettingsData.agroupedEvents.join(";")
          : ""
        : "",
      circus: getters.getEventSettingsData.hasElevenAccess ? 1 : 0,
      facial: getters.getEventSettingsData.hasFacial,
      limite_uso: getters.getEventSettingsData.accessQuantity,
      dthr_inicio_checkin: getters.getEventSettingsData.accessPeriodStart,
      dthr_termino_checkin: getters.getEventSettingsData.accessPeriodEnd,
      carteira_digital: [
        {
          ...getters.getEventSettingsData.balanceSettings,
          limite: getters.getEventSettingsData.balanceReleased,
        },
      ],
      tipo_taxa_web:
        getters.getEventSettingsData.commissionWeb || "CONVENIENCIA",
      comissao_web:
        getters.getEventSettingsData.commissionWeb === "COMISSAO"
          ? getters.getEventSettingsData.typeTaxWeb === "value"
            ? getters.getEventSettingsData.taxWeb
            : "0"
          : "0",
      comissao_porcentagem_custom_web:
        getters.getEventSettingsData.commissionWeb === "COMISSAO"
          ? getters.getEventSettingsData.typeTaxWeb === "percent"
            ? getters.getEventSettingsData.taxWeb
            : "0"
          : "0",
      taxa_conveniencia_web:
        getters.getEventSettingsData.commissionWeb === "CONVENIENCIA"
          ? getters.getEventSettingsData.typeTaxWeb === "value"
            ? getters.getEventSettingsData.taxWeb
            : "0"
          : "0",
      taxa_conveniencia_porcentagem_custom_web:
        getters.getEventSettingsData.commissionWeb === "CONVENIENCIA"
          ? getters.getEventSettingsData.typeTaxWeb === "percent"
            ? getters.getEventSettingsData.taxWeb
            : "0"
          : "0",

      tipo_taxa_pos: getters.getEventSettingsData.commissionPos || "COMISSAO",
      comissao_pos:
        getters.getEventSettingsData.commissionPos === "COMISSAO"
          ? getters.getEventSettingsData.typeTaxPos === "value"
            ? getters.getEventSettingsData.taxPos
            : "0"
          : "0",
      comissao_porcentagem_custom_pos:
        getters.getEventSettingsData.commissionPos === "COMISSAO"
          ? getters.getEventSettingsData.typeTaxPos === "percent"
            ? getters.getEventSettingsData.taxPos
            : "0"
          : "0",
      taxa_conveniencia_pos:
        getters.getEventSettingsData.commissionPos === "CONVENIENCIA"
          ? getters.getEventSettingsData.typeTaxPos === "value"
            ? getters.getEventSettingsData.taxPos
            : "0"
          : "0",
      taxa_conveniencia_porcentagem_custom_pos:
        getters.getEventSettingsData.commissionPos === "CONVENIENCIA"
          ? getters.getEventSettingsData.typeTaxPos === "percent"
            ? getters.getEventSettingsData.taxPos
            : "0"
          : "0",

      taxa_processamento: getters.getEventSettingsData.hasProcessingTax
        ? getters.getEventSettingsData.processingTax
        : "0",
      taxa_minima: getters.getEventSettingsData.minimumTax || "2.5",

      controla_cancelamento:
        getters.getEventSettingsData.cancellationPeriod === "disabled" ? 0 : 1,
      horas_canc_antes_evento: getters.getEventSettingsData.cancellationHours,
      dias_canc_apos_compra: getters.getEventSettingsData.cancellationDays,
      tipo: getters.eventType,
      status: getters.getEventSettingsData.publication,
    };

    return { ...settingsData, ...infoData, imagens: imagensJsonString };
  },
  async getTicketsToPayload({ getters, dispatch }) {
    const eventDate = getters.getEventBasicData.eventDate;
    if (getters.getProductList && getters.getProductList.length > 0) {
      const productWithoutImages = getters.getProductList.find(
        product => !product.images || product.images.length === 0
      );

      if (productWithoutImages) {
        dispatch(
          "showSnackbarError",
          i18n.t("new-event.ticket-management.products.min-image")
        );
        throw new Error(
          i18n.t("new-event.ticket-management.products.min-image")
        );
      }
    }

    function formatDate(dateToFormat) {
      const date = new Date(dateToFormat);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
      return formattedDate;
    }

    function buildCommonFields(item, index) {
      const {
        idproduto_variacao,
        nidvariacao,
        description,
        status,
        quantity,
        price,
        processingTax,
        commissionWeb,
        commissionPos,
        typeTaxWeb,
        typeTaxPos,
        taxWeb,
        taxPos,
        minimumTax,
        type,
        salesChannel,
        accessQuantity,
        accessPeriodStart,
        accessPeriodEnd,
        isCourtesy,
        blockQuantity,
        ticketDate,
      } = item;

      return {
        idproduto_variacao,
        nidvariacao,
        dthr_ingresso:
          getters.getEventBasicData.frequency === "UNICO"
            ? eventDate
            : ticketDate,
        descritivo: description,
        status,
        quantidade: quantity,
        preco: price,
        taxa: isCourtesy ? "CORTESIA" : "",
        canal_venda: salesChannel,
        ordenacao: index,
        quantidade_bloqueada: blockQuantity,
        tipo: type,
        limite_uso: accessQuantity,
        dthr_inicio_checkin: accessPeriodStart,
        dthr_termino_checkin: accessPeriodEnd,
        cortesia: isCourtesy ? 1 : 0,
        gratuidade: 0,
        taxa_processamento: processingTax,
        tipo_taxa_web: commissionWeb || "CONVENIENCIA",
        tipo_taxa_pos: commissionPos || "COMISSAO",
        taxa_conveniencia_web:
          commissionWeb === "CONVENIENCIA"
            ? typeTaxWeb === "value"
              ? taxWeb
              : "0"
            : "0",
        taxa_conveniencia_pos:
          commissionPos === "CONVENIENCIA"
            ? typeTaxPos === "value"
              ? taxPos
              : "0"
            : "0",
        taxa_conveniencia_porcentagem_custom_web:
          commissionWeb === "CONVENIENCIA"
            ? typeTaxWeb === "percent"
              ? taxWeb
              : "0"
            : "0",
        taxa_conveniencia_porcentagem_custom_pos:
          commissionPos === "CONVENIENCIA"
            ? typeTaxPos === "percent"
              ? taxPos
              : "0"
            : "0",
        comissao_porcentagem_custom_web:
          commissionWeb === "COMISSAO"
            ? typeTaxWeb === "percent"
              ? taxWeb
              : "0"
            : "0",
        comissao_porcentagem_custom_pos:
          commissionPos === "COMISSAO"
            ? typeTaxPos === "percent"
              ? taxPos
              : "0"
            : "0",
        comissao_web:
          commissionWeb === "COMISSAO"
            ? typeTaxWeb === "value"
              ? taxWeb
              : "0"
            : "0",
        comissao_pos:
          commissionPos === "COMISSAO"
            ? typeTaxPos === "value"
              ? taxPos
              : "0"
            : "0",
        taxa_minima: minimumTax,
      };
    }

    const tickets = getters.getTicketList.map((ticket, index) => {
      function areConfigurationsEqual(ticketConfig, generalConfig, fields) {
        return fields.every(
          field => ticketConfig[field] === generalConfig[field]
        );
      }
      const eventSettings = getters.getEventSettingsData;
      const cachedSettings = getters.getEventSettingsDataCached;

      const commissionFields = [
        "typeTaxWeb",
        "typeTaxPos",
        "commissionWeb",
        "commissionPos",
        "taxWeb",
        "taxPos",
        "processingTax",
        "minimumTax",
      ];

      const accessPeriodFields = [
        "accessPeriodStart",
        "accessPeriodEnd",
        "accessQuantity",
      ];

      const areCommissionsEqual = areConfigurationsEqual(
        ticket,
        cachedSettings,
        commissionFields
      );

      const areAccessPeriodsEqual = areConfigurationsEqual(
        ticket,
        cachedSettings,
        accessPeriodFields
      );

      const processedCommissionWeb =
        eventSettings.applyAllCommissions || areCommissionsEqual
          ? eventSettings.commissionWeb
          : ticket.commissionWeb;

      const processedCommissionPos =
        eventSettings.applyAllCommissions || areCommissionsEqual
          ? eventSettings.commissionPos
          : ticket.commissionPos;

      const processedTaxWeb =
        eventSettings.applyAllCommissions || areCommissionsEqual
          ? eventSettings.taxWeb
          : ticket.taxWeb;

      const processedTypeTaxWeb =
        eventSettings.applyAllCommissions || areCommissionsEqual
          ? eventSettings.typeTaxWeb
          : ticket.typeTaxWeb;

      const processedTypeTaxPos =
        eventSettings.applyAllCommissions || areCommissionsEqual
          ? eventSettings.typeTaxPos
          : ticket.typeTaxPos;

      const processedTaxPos =
        eventSettings.applyAllCommissions || areCommissionsEqual
          ? eventSettings.taxPos
          : ticket.taxPos;

      const processedProcessingTax =
        eventSettings.applyAllCommissions || areCommissionsEqual
          ? eventSettings.processingTax
          : ticket.processingTax;

      const processedMinimumTax =
        eventSettings.applyAllCommissions || areCommissionsEqual
          ? eventSettings.minimumTax
          : ticket.minimumTax;

      const processedAccessPeriodStart =
        eventSettings.applyAllAccessPeriods || areAccessPeriodsEqual
          ? eventSettings.accessPeriodStart
          : ticket.accessPeriodStart;

      const processedAccessPeriodEnd =
        eventSettings.applyAllAccessPeriods || areAccessPeriodsEqual
          ? eventSettings.accessPeriodEnd
          : ticket.accessPeriodEnd;

      const processedAccessQuantity =
        eventSettings.applyAllAccessPeriods || areAccessPeriodsEqual
          ? eventSettings.accessQuantity
          : ticket.accessQuantity;

      return {
        ...buildCommonFields(ticket, index),
        taxa_processamento: processedProcessingTax,
        tipo_taxa_web: processedCommissionWeb,
        tipo_taxa_pos: processedCommissionPos,
        taxa_conveniencia_web:
          processedCommissionWeb === "CONVENIENCIA"
            ? processedTypeTaxWeb === "value"
              ? processedTaxWeb
              : "0"
            : "0",
        taxa_conveniencia_pos:
          processedCommissionPos === "CONVENIENCIA"
            ? processedTypeTaxPos === "value"
              ? processedTaxPos
              : "0"
            : "0",
        taxa_conveniencia_porcentagem_custom_web:
          processedCommissionWeb === "CONVENIENCIA"
            ? processedTypeTaxWeb === "percent"
              ? processedTaxWeb
              : "0"
            : "0",
        taxa_conveniencia_porcentagem_custom_pos:
          processedCommissionPos === "CONVENIENCIA"
            ? processedTypeTaxPos === "percent"
              ? processedTaxPos
              : "0"
            : "0",
        comissao_porcentagem_custom_web:
          processedCommissionWeb === "COMISSAO"
            ? processedTypeTaxWeb === "percent"
              ? processedTaxWeb
              : "0"
            : "0",
        comissao_porcentagem_custom_pos:
          processedCommissionPos === "COMISSAO"
            ? processedTypeTaxPos === "percent"
              ? processedTaxPos
              : "0"
            : "0",
        comissao_web:
          processedCommissionWeb === "COMISSAO"
            ? processedTypeTaxWeb === "value"
              ? processedTaxWeb
              : "0"
            : "0",
        comissao_pos:
          processedCommissionPos === "COMISSAO"
            ? processedTypeTaxPos === "value"
              ? processedTaxPos
              : "0"
            : "0",
        taxa_minima: processedMinimumTax,
        descricao: transformToXmlFormat(
          ticket.name,
          ticket.nameLocales,
          i18n.locale
        ),
        dthr_inicio_checkin: processedAccessPeriodStart,
        dthr_termino_checkin: processedAccessPeriodEnd,
        limite_uso: processedAccessQuantity,
        dthr_inicio_vendas: ticket.salesPeriodStart
          ? ticket.salesPeriodStart
          : getters.getEventBasicData.saleStart,
        dthr_termino_vendas: ticket.salesPeriodEnd
          ? ticket.salesPeriodEnd
          : getters.getEventBasicData.saleEnd,
        idprod_var_lote: ticket.previousBatch,
        dthr_virada_lote: ticket.dateChangeBatch,
        ordem_lote: ticket.batch,
        idsetor: ticket.sector,
        meio_ingresso: ticket.half,
      };
    });

    const recharges = getters.getRechargeList.map((recharge, index) => ({
      ...buildCommonFields(recharge, index),
      descricao: "Recarga",
      dthr_inicio_vendas: formatDate(recharge.salesPeriodStart),
      dthr_termino_vendas: formatDate(recharge.salesPeriodEnd),
      codigo_eleven_cash: recharge.elevenCash,
    }));

    const products = getters.getProductList.map((product, index) => ({
      ...buildCommonFields(product, index),
      imagem: product.images,
      descricao: transformToXmlFormat(
        product.name,
        product.nameLocales,
        i18n.locale
      ),
      variacoes:
        product?.variation?.length > 0
          ? product.variation.map(variation => ({
              idvariacao_produto: variation.idvariacao_produto,
              tamanho: variation.size || "",
              cor: variation.color || "",
              nome_cor: variation.colorName,
              quantidade: variation.quantity || 0,
              status: variation.status,
            }))
          : null,
    }));

    return [...tickets, ...recharges, ...products];
  },
  async doubleEvent({ commit, getters, dispatch }, idevent) {
    commit("setLoadingDoubleEvent", true);
    router.push({
      name: "doubleEventSetting",
      params: { type: "duplicar-event" },
    });
    try {
      await getEventInfo({
        idevent: idevent,
        loja: getters.storeSequencial,
      }).then(async response => {
        commit("setSelectedLocales", extractAndRemoveLocale(response.data));
        commit("setEventType", response.data.tipo);
        commit("setEventBasicData", {
          name: response.data.descricao,
          description: response.data.descritivo,
          expandDescription: response.data.ver_mais === 1,
          category: response.data.idcategoria,
          urlLink: response.data.url_link,
          frequency: response.data.dthr_apresentacao ? "UNICO" : "RECORRENTE",
          eventDate: response.data.dthr_apresentacao,
          saleStart: response.data.dthr_inicio,
          saleEnd: response.data.dthr_termino,
          location: response.data.end_local,
          showMap: response.data.show_map === 1 ? true : false,
          country: response.data.end_pais,
          state: response.data.end_estado,
          city: response.data.end_cidade,
        });

        await dispatch("populateLocation");
        await dispatch("createEvent").then(async () => {
          await fetchSectors({
            idevent: idevent,
            loja: getters.storeSequencial,
          }).then(async response => {
            if (response.data?.length > 0) {
              let sectors = response.data.map(sector => sector.descricao);
              await dispatch("createSector", sectors);
              getters.getEventSectorData.hasSector = true;
            }
          });

          const sortedVariations =
            response.data.variantes?.variacoes_produto?.sort(
              (a, b) => a.ordenacao - b.ordenacao
            );

          const hasBatchs = sortedVariations?.some(
            variation => variation.ordem_lote > 1
          );

          for (const variation of sortedVariations) {
            const response = await createTickets({
              idevent: getters.getIdEvent,
              loja: getters.storeSequencial,
              type: variation.tipo,
            });

            const translatedDescriptions = processEventName(
              variation.descricao
            );

            if (variation.tipo === "INGRESSO") {
              const processSector = getters.getEventSectorData.sectors?.find(
                sector => sector.descricao === variation.setor_descricao
              );
              let disabled = [];

              if (hasBatchs && variation.ordem_lote > 0) {
                disabled.push("batch");
                disabled.push("sector");
              }

              if (variation.cortesia === 1 || variation.gratuidade === 1) {
                disabled.push("price");
              }

              if (variation.meio_ingresso) {
                disabled.push("price");
              }

              commit("addTicketToList", {
                idproduto_variacao: response.data.idproduto_variacao,
                nidvariacao: response.data.nidvariacao,
                id: response.data.idproduto_variacao,
                name: translatedDescriptions[i18n.locale],
                nameLocales: translatedDescriptions,
                sector: processSector?.idsetor,
                disabled: disabled.length > 0 ? disabled : "",
                batch: variation.ordem_lote,
                order: variation.ordenacao,
                price: variation.preco,
                half: variation.meio_ingresso,
                quantity: variation.quantidade,
                salesChannel: variation.canal_venda,
                description: variation.descritivo,
                accessPeriodStart: variation.dthr_inicio_checkin,
                accessPeriodEnd: variation.dthr_termino_checkin,
                salesPeriodStart: variation.dthr_inicio_vendas,
                salesPeriodEnd: variation.dthr_termino_vendas,
                accessQuantity: variation.limite_uso,
                dateChangeBatch: variation.dthr_virada_lote,
                isCourtesy: variation.cortesia === 1,
                blockQuantity: variation.quantidade_bloqueada,
                commissionWeb: variation.tipo_taxa_web,
                typeTaxWeb:
                  variation.taxa_conveniencia_porcentagem_custom_web > 0 ||
                  variation.comissao_porcentagem_custom_web > 0
                    ? "percent"
                    : "value",
                taxWeb:
                  [
                    variation.comissao_web,
                    variation.taxa_conveniencia_web,
                    variation.taxa_conveniencia_porcentagem_custom_web,
                    variation.comissao_porcentagem_custom_web,
                  ].find(value => value > 0) || 0,
                minimumTax: variation.taxa_minima,
                commissionPos: variation.tipo_taxa_pos,
                typeTaxPos:
                  variation.taxa_conveniencia_porcentagem_custom_pos > 0 ||
                  variation.comissao_porcentagem_custom_pos > 0
                    ? "percent"
                    : "value",
                taxPos:
                  [
                    variation.comissao_pos,
                    variation.taxa_conveniencia_pos,
                    variation.taxa_conveniencia_porcentagem_custom_pos,
                    variation.comissao_porcentagem_custom_pos,
                  ].find(value => value > 0) || 0,
                hasProcessingTax: variation.taxa_processamento > 0,
                processingTax: variation.taxa_processamento,
                type: "INGRESSO",
                status: variation.status,
                previousBatch: variation.idprod_var_lote,
              });
            }

            if (variation.tipo === "RECARGA") {
              commit("addRechargeToList", {
                idproduto_variacao: response.data.idproduto_variacao,
                nidvariacao: response.data.nidvariacao,
                id: response.data.idproduto_variacao,
                price: variation.preco,
                order: variation.ordenacao,
                quantity: variation.quantidade,
                salesPeriodStart: variation.dthr_inicio_vendas,
                salesPeriodEnd: variation.dthr_termino_vendas,
                salesChannel: variation.canal_venda,
                description: variation.descritivo,
                commissionWeb: variation.tipo_taxa_web,
                typeTaxWeb:
                  variation.taxa_conveniencia_porcentagem_custom_web > 0 ||
                  variation.comissao_porcentagem_custom_web > 0
                    ? "percent"
                    : "value",
                taxWeb:
                  [
                    variation.comissao_web,
                    variation.taxa_conveniencia_web,
                    variation.taxa_conveniencia_porcentagem_custom_web,
                    variation.comissao_porcentagem_custom_web,
                  ].find(value => value > 0) || 0,
                minimumTax: variation.taxa_minima,
                commissionPos: variation.tipo_taxa_pos,
                typeTaxPos:
                  variation.taxa_conveniencia_porcentagem_custom_pos > 0 ||
                  variation.comissao_porcentagem_custom_pos > 0
                    ? "percent"
                    : "value",
                taxPos:
                  [
                    variation.comissao_pos,
                    variation.taxa_conveniencia_pos,
                    variation.taxa_conveniencia_porcentagem_custom_pos,
                    variation.comissao_porcentagem_custom_pos,
                  ].find(value => value > 0) || 0,
                hasProcessingTax: variation.taxa_processamento > 0,
                processTax: variation.taxa_processamento,
                elevenCash: variation.codigo_eleven_cash,
                status: variation.status,
                type: "RECARGA",
              });
            }

            if (variation.tipo === "PRODUTO") {
              commit("addProductToList", {
                disabled: "quantity",
                idproduto_variacao: response.data.idproduto_variacao,
                nidvariacao: response.data.nidvariacao,
                id: response.data.idproduto_variacao,
                name: translatedDescriptions[i18n.locale],
                nameLocales: translatedDescriptions,
                order: variation.ordenacao,
                images: variation.imagem,
                price: variation.preco,
                quantity: variation.quantidade,
                accessPeriodStart: variation.dthr_inicio_checkin,
                accessPeriodEnd: variation.dthr_termino_checkin,
                accessQuantity: variation.limite_uso,
                salesChannel: variation.canal_venda,
                description: variation.descritivo,
                commissionWeb: variation.tipo_taxa_web,
                typeTaxWeb:
                  variation.taxa_conveniencia_porcentagem_custom_web > 0 ||
                  variation.comissao_porcentagem_custom_web > 0
                    ? "percent"
                    : "value",
                taxWeb:
                  [
                    variation.comissao_web,
                    variation.taxa_conveniencia_web,
                    variation.taxa_conveniencia_porcentagem_custom_web,
                    variation.comissao_porcentagem_custom_web,
                  ].find(value => value > 0) || 0,
                minimumTax: variation.taxa_minima,
                commissionPos: variation.tipo_taxa_pos,
                typeTaxPos:
                  variation.taxa_conveniencia_porcentagem_custom_pos > 0 ||
                  variation.comissao_porcentagem_custom_pos > 0
                    ? "percent"
                    : "value",
                taxPos:
                  [
                    variation.comissao_pos,
                    variation.taxa_conveniencia_pos,
                    variation.taxa_conveniencia_porcentagem_custom_pos,
                    variation.comissao_porcentagem_custom_pos,
                  ].find(value => value > 0) || 0,
                hasProcessingTax: variation.taxa_processamento > 0,
                processTax: variation.taxa_processamento,
                type: "PRODUTO",
                status: variation.status,
                variation: Promise.all(
                  variation.variacoes?.map(async item => {
                    const varResponse = await createVariationProduct({
                      loja: getters.storeSequencial,
                      idevent: getters.getIdEvent,
                      idproduto_variacao: variation.idproduto_variacao,
                    });

                    return {
                      idvariacao_produto: varResponse.data.idvariacao_produto,
                      size: item.tamanho,
                      color: item.cor,
                      quantity: item.quantidade,
                      status: item.status,
                    };
                  }) || []
                ),
              });
            }
          }
        });

        commit("setEventImages", convertObjectToArray(response.data.imagens));
        const digitalWallet = response.data?.carteira_digital?.[0];
        const settingsData = {
          viewType: response.data.dthr_pre_venda,
          emphasis: response.data.destaque === 1,
          changeBearer: this.getCurrentEvent.troca_portador === 1,
          limitPerCustomer: (() => {
            try {
              return (
                JSON.parse(response.data.limite_venda_cpf_por_tipo)?.ingresso ||
                5
              );
            } catch (e) {
              return 5;
            }
          })(),
          url: getters.getEventSettingsData.url,
          accessPeriodStart: response.data.dthr_inicio_checkin,
          accessPeriodEnd: response.data.dthr_termino_checkin,
          accessQuantity: response.data.limite_uso,
          hasElevenAccess: response.data.circus === 1,
          hasFacial: response.data.is_facial === 1,
          showAgroupedEventsOnElevenTickets: response.data.exibe_agrupamento,
          agroupedEvents: response.data.nidprod_agrupamento?.split(";"),
          hasAgroupedEvents: response.data.prod_agrupamento === 1,
          balanceReleased: digitalWallet?.limite || 0,
          balanceSettings: digitalWallet?.balanceSettings || 0,
          commissionWeb: response.data.tipo_taxa_web || "COMISSAO",
          typeTaxWeb:
            response.data.taxa_conveniencia_porcentagem_custom_web > 0 ||
            response.data.comissao_porcentagem_custom_web > 0
              ? "percent"
              : "value",
          taxWeb:
            [
              response.data.comissao_web,
              response.data.taxa_conveniencia_web,
              response.data.taxa_conveniencia_porcentagem_custom_web,
              response.data.comissao_porcentagem_custom_web,
            ].find(value => value > 0) || 0,
          minimumTax: response.data.taxa_minima,

          commissionPos: response.data.tipo_taxa_pos || "CONVENIENCIA",
          typeTaxPos:
            response.data.taxa_conveniencia_porcentagem_custom_pos > 0 ||
            response.data.comissao_porcentagem_custom_pos > 0
              ? "percent"
              : "value",
          taxPos:
            [
              response.data.comissao_pos,
              response.data.taxa_conveniencia_pos,
              response.data.taxa_conveniencia_porcentagem_custom_pos,
              response.data.comissao_porcentagem_custom_pos,
            ].find(value => value > 0) || 0,
          hasProcessingTax: response.data.taxa_processamento > 0,
          processingTax: response.data.taxa_processamento,
          cancellationPeriod:
            response.data.controla_cancelamento === 0 ? "disabled" : "default",
          cancellationDays: response.data.dias_canc_apos_compra,
          cancellationHours: response.data.horas_canc_antes_evento,
          publication: response.data.status,
        };

        commit("setEventSettingsDataCached", { ...settingsData });
        commit("setEventSettingsData", { ...settingsData });
        await dispatch("updateEvent");
      });
    } catch (error) {
      router.push({
        name: "events",
      });
      console.error(error);
      throw error;
    } finally {
      commit("setLoadingDoubleEvent", false);
    }
  },
  async createBulkTickets({ commit, getters }, infoBulkInserion) {
    const { ticket, dates } = infoBulkInserion;
    const infoTicket = {
      descritivo: ticket.description,
      status: ticket.status,
      quantidade: ticket.quantity,
      preco: ticket.price,
      taxa:
        ticket.courtesyOrGratuity === "courtesy" ||
        ticket.courtesyOrGratuity === "gratuity"
          ? "CORTESIA"
          : "",
      canal_venda: ticket.salesChannel,
      quantidade_bloqueada: ticket.blockQuantity,
      tipo: ticket.type,
      limite_uso: ticket.accessQuantity,
      dthr_inicio_checkin: ticket.accessPeriodStart,
      dthr_termino_checkin: ticket.accessPeriodEnd,
      cortesia: ticket.courtesyOrGratuity === "courtesy" ? 1 : 0,
      gratuidade: ticket.courtesyOrGratuity === "gratuity" ? 1 : 0,
      taxa_processamento: ticket.processingTax,
      tipo_taxa_web: ticket.commissionWeb || "CONVENIENCIA",
      tipo_taxa_pos: ticket.commissionPos || "COMISSAO",
      taxa_conveniencia_web:
        ticket.commissionWeb === "CONVENIENCIA"
          ? ticket.typeTaxWeb === "value"
            ? ticket.taxWeb
            : "0"
          : "0",
      taxa_conveniencia_pos:
        ticket.commissionPos === "CONVENIENCIA"
          ? ticket.typeTaxPos === "value"
            ? ticket.taxPos
            : "0"
          : "0",
      taxa_conveniencia_porcentagem_custom_web:
        ticket.commissionWeb === "CONVENIENCIA"
          ? ticket.typeTaxWeb === "percent"
            ? ticket.taxWeb
            : "0"
          : "0",
      taxa_conveniencia_porcentagem_custom_pos:
        ticket.commissionPos === "CONVENIENCIA"
          ? ticket.typeTaxPos === "percent"
            ? ticket.taxPos
            : "0"
          : "0",
      comissao_porcentagem_custom_web:
        ticket.commissionWeb === "COMISSAO"
          ? ticket.typeTaxWeb === "percent"
            ? ticket.taxWeb
            : "0"
          : "0",
      comissao_porcentagem_custom_pos:
        ticket.commissionPos === "COMISSAO"
          ? ticket.typeTaxPos === "percent"
            ? ticket.taxPos
            : "0"
          : "0",
      comissao_web:
        ticket.commissionWeb === "COMISSAO"
          ? ticket.typeTaxWeb === "value"
            ? ticket.taxWeb
            : "0"
          : "0",
      comissao_pos:
        ticket.commissionPos === "COMISSAO"
          ? ticket.typeTaxPos === "value"
            ? ticket.taxPos
            : "0"
          : "0",
      taxa_minima: ticket.minimumTax,
      descricao: transformToXmlFormat(
        ticket.name,
        ticket.nameLocales,
        i18n.locale
      ),
      idprod_var_lote: ticket.previousBatch,
      dthr_virada_lote: ticket.dateChangeBatch,
      ordem_lote: ticket.batch,
      idsetor: ticket.sector,
    };

    try {
      commit("setLoadingBulkEvent", true);
      const createdTickets = await insertBulkTickets({
        loja: getters.storeSequencial,
        idevent: getters.getIdEvent,
        ticket: infoTicket,
        dates,
      });
      createdTickets?.data?.ingressos?.forEach(createdTicket => {
        commit("addTicketToList", {
          ...ticket,
          ticketDate: createdTicket.dthr_ingresso,
          idproduto_variacao: createdTicket.idproduto_variacao,
          nidvariacao: createdTicket.nidvariacao,
        });
      });
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      commit("setLoadingBulkEvent", false);
    }
  },
  async canChangeEventType({ getters, dispatch }) {
    try {
      const response = await canChangeEventType({
        loja: getters.storeSequencial,
        idevent: getters.getIdEvent,
      });
      return response.data;
    } catch (error) {
      dispatch("showSnackbarError", error.msg);
      throw error;
    }
  },
  async canRemoveDateFromRecurringEvent({ getters, dispatch }, date) {
    try {
      const response = await removeDateFromRecurringEvent({
        loja: getters.storeSequencial,
        idevent: getters.getIdEvent,
        date: date,
      });
      return response.data;
    } catch (error) {
      dispatch("showSnackbarError", error.msg);
      throw error;
    }
  },
};

const mutations = {
  setSelectedLocales(state, selectedLocales) {
    state.selectedLocales = selectedLocales;
  },
  setCategories(state, categories) {
    state.categories = categories;
  },
  setCurrentEvent(state, event) {
    state.currentEvent = event;
  },
  setIdEvent(state, idEvent) {
    state.idEvent = idEvent;
  },
  setEventType(state, eventType) {
    state.eventType = eventType;
  },
  setLoadingCategories(state, loadingCategories) {
    state.loadingCategories = loadingCategories;
  },
  setLoadingEvents(state, loadingEvents) {
    state.loadingEvents = loadingEvents;
  },
  setLoadingEvent(state, loadingEvent) {
    state.loadingEvent = loadingEvent;
  },
  setModalLoadingEvent(state, modalLoadingEvent) {
    state.modalLoadingEvent = modalLoadingEvent;
  },
  setEventBasicData(state, eventBasicData) {
    state.eventBasicData = eventBasicData;
  },
  setEventSectorData(state, eventSectorData) {
    state.eventSectorData = eventSectorData;
  },
  setEventSettingsData(state, eventSettingsData) {
    state.eventSettingsData = eventSettingsData;
  },
  setEventSettingsDataCached(state, eventSettingsDataCached) {
    state.eventSettingsDataCached = eventSettingsDataCached;
  },
  setEventImages(state, image) {
    state.eventImages = image;
  },
  setEventImagesLoading(state, eventImagesLoading) {
    state.eventImagesLoading = eventImagesLoading;
  },
  setTypeImageSelected(state, typeImageSelected) {
    state.typeImageSelected = typeImageSelected;
  },
  setTicketList(state, ticketList) {
    state.ticketList = ticketList;
  },
  setProductList(state, productList) {
    state.productList = productList;
  },
  setRechargeList(state, rechargeList) {
    state.rechargeList = rechargeList;
  },
  setLoadingDoubleEvent(state, loadingDoubleEvent) {
    state.loadingDoubleEvent = loadingDoubleEvent;
  },
  addSelectedDateToTickets(state, selectedDateToTickets) {
    state.selectedDateToTickets.push(selectedDateToTickets);
  },
  setSelectedDateToTickets(state, selectedDateToTickets) {
    state.selectedDateToTickets = selectedDateToTickets;
  },
  addDatesOfTickets(state, datesOfTickets) {
    datesOfTickets.forEach(date => {
      state.datesOfTickets.push(date);
    });
  },
  setDatesOfTickets(state, datesOfTickets) {
    state.datesOfTickets = datesOfTickets;
  },
  setLoadingBulkEvent(state, loadingBulkEvent) {
    state.loadingBulkEvent = loadingBulkEvent;
  },
  addRechargeToList(state, recharge) {
    state.rechargeList.push(recharge);
  },
  addProductToList(state, product) {
    state.productList.push(product);
  },
  addTicketToList(state, ticket) {
    state.ticketList.push(ticket);
  },
  addProductVariationToList(state, { productListId, variation }) {
    const productList = state.productList.find(
      product => product.idproduto_variacao === productListId
    );
    if (productList) {
      if (!productList.variation) {
        productList.variation = [];
      }
      productList.variation = [...productList.variation, variation];
    }
  },
  deleteProductVariationToList(_, { eventData, variation }) {
    const index = eventData?.variation?.findIndex(
      v => v.idvariacao_produto === variation.idvariacao_produto
    );
    if (index !== -1) {
      eventData?.variation?.splice(index, 1);
    }
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
